export default __webpack_public_path__ + "static/media/ws.0fee650a.svg";